import _get from 'lodash/get';
import {
  GET_USER_SIGNED_TOKEN_REQUEST,
  GET_USER_SIGNED_TOKEN_SUCCESS,
  GET_USER_SIGNED_TOKEN_FAILURE,
} from '../../types';

const initialState = {
  token: null,
  hasPaymentMethod: false,
  status: {
    isLoading: false,
    isLoaded: false,
    error: false,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_SIGNED_TOKEN_REQUEST:
      return {
        ...initialState,
        status: {
          ...initialState.status,
          isLoading: true,
        },
      };
    case GET_USER_SIGNED_TOKEN_SUCCESS:
      return {
        token: _get(action, 'payload.token', ''),
        hasPaymentMethod: _get(action, 'payload.hasPaymentMethod', false),
        status: {
          isLoading: false,
          isLoaded: true,
          error: false,
        },
      };
    case GET_USER_SIGNED_TOKEN_FAILURE:
      return {
        ...initialState,
        status: {
          isLoading: false,
          isLoaded: true,
          error: true,
        },
      };
    default:
      return state;
  }
};
